exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navbar[data-v-9e84d7d4]{background-size:10% auto;background-color:#fcd599}.navbar .navbar-brand[data-v-9e84d7d4]{width:50%;position:absolute;left:50%;top:50%;transform:translateY(-50%) translateX(-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-9e84d7d4&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/global/partials/GuestHeader/MobileHeader.vue
// module id = 532
// module chunks = 0